<nb-card class="card-container nb_card_pop_up full_pop_up mobilePopup">
  <nb-card-header>
    <div i18n="@@EditAssessmentData" class="title">Edit Assessment Data</div>

    <div class="actions">
      <button nbButton ghost tabindex="-1">
        <nb-icon icon="close-outline" (click)="Back()" style="z-index: 1000;"></nb-icon>
      </button>

    </div>
  </nb-card-header>
  <nb-card-body [nbSpinner]="isLoading">
    <div class="form-group row">
      <div class="col-12">
        <b><span i18n="@@Patient">Patient</span>: {{PatientName}}</b>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12">
        <b><span i18n="@@Dates">Dates</span>: {{StartDate}} - {{EndDate}}</b>
      </div>
    </div>
    <form *ngIf="formlyForm" [formGroup]="AssessmentForm">
      <formly-form [model]="model" [fields]="formlyForm" [options]="options" [form]="AssessmentForm"></formly-form>
      <div *ngIf="!isLoading && isImageProgressUpload">
        <app-image-upload [label]="'Front Image'" [imageSrc]="model.progressImageUrl"
          (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImage)"
          (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImage)">
        </app-image-upload>
        <app-image-upload [label]="'Back Image'" [imageSrc]="model.progressImageLeftUrl"
          (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImageLeft)"
          (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImageLeft)">
        </app-image-upload>

        <app-image-upload [label]="'Side Image'" [imageSrc]="model.progressImageRightUrl"
          (onImageChange)="OnInputImageFileChanged($event, assessmentProgressImageType.ProgressImageRight)"
          (onResetImage)="onResetFoodImage(assessmentProgressImageType.ProgressImageRight)">
        </app-image-upload>
      </div>
    </form>
  </nb-card-body>
  <nb-card-footer>
    <div class="actions float-right">
      <button *ngIf="formlyForm" i18n="@@SaveAssessment" nbButton type="submit" [nbSpinner]="isLoading"
        class="btn-circle btn-xl btn-main btn-circle btn-xl" (click)="SaveAssessment()"
        [disabled]="!AssessmentForm.valid||isLoading">Save Assessment</button>
    </div>
  </nb-card-footer>
</nb-card>
